import { Directive, HostBinding, Input } from '@angular/core';
import { BrandService } from '../service/brand.service';

export type BrandLogoVariant = 'icon' | 'vertical-dark' | 'text-dark' | 'text-white' | 'primary' | 'primary-white';

/**
 * Drives an <img> from the active brand's logo set, so the shell chrome stops
 * hard-coding `src="assets/img/logos/frankli-logo*.svg"`. Applied as an
 * attribute (`<img appBrandLogo="text-dark">`) rather than a wrapping component
 * so the element stays a plain <img> and its existing classes and layout are
 * untouched. The alt text follows the brand name.
 */
@Directive({
  selector: 'img[appBrandLogo]'
})
export class BrandLogoDirective {
  @Input('appBrandLogo') variant: BrandLogoVariant | '' = 'icon';

  constructor(private readonly brandService: BrandService) {}

  @HostBinding('attr.src')
  get src(): string {
    const logos = this.brandService.logos;
    switch (this.variant) {
      case 'vertical-dark': return logos.verticalDark;
      case 'text-dark': return logos.textDark;
      case 'text-white': return logos.textWhite;
      case 'primary': return logos.primary;
      case 'primary-white': return logos.primaryWhite;
      case 'icon':
      default: return logos.iconOnly;
    }
  }

  @HostBinding('attr.alt')
  get alt(): string {
    return this.brandService.name;
  }
}
